var React = require('react');

function KbdShift (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 8.489L7.995 0 16 8.489h-4.002V16H4.002V8.489H0zm7.995-6.743L2.687 7.382h2.471v7.391h5.684V7.382h2.462L7.995 1.746z"}));
}

KbdShift.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = KbdShift;

KbdShift.default = KbdShift;
